import React from 'react';
import { Routes, Route } from 'react-router-dom';
import useAuthContext from '../../contexts/AuthContext';
import { Accounting } from './Accounting';
import { CustomerAccounting } from './CustomerAccounting';

export const AccountingRouter = () => {
  const { user } = useAuthContext();

  const AccountingComponent =
    user?.role === 'guests:GUEST' ? CustomerAccounting : Accounting;

  return (
    <Routes>
      <Route index element={<AccountingComponent />} />
    </Routes>
  );
};
